export default {
      id: "icon-twitter-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }